import { ApiError } from 'api-new/generated';
import { createElement, ReactElement } from 'react';

export type ValidationError = {
  type?: string;
  title?: string;
  status?: number;
  errors?: Record<string, string[]>;
  traceId?: string;
};

export const isValidationError = (error: unknown): error is ValidationError => {
  return (
    typeof error === 'object' &&
    error !== null &&
    'errors' in error &&
    typeof (error as ValidationError).errors === 'object'
  );
};

export const createValidationErrorToast = (error: ValidationError): ReactElement => {
  return createElement(
    'div',
    null,
    createElement('strong', null, error.title ?? 'Validation failed'),
    error.errors &&
      createElement(
        'ul',
        { style: { margin: '8px 0 0', paddingLeft: '16px' } },
        Object.entries(error.errors).map(([field, messages]) =>
          createElement('li', { key: field }, createElement('strong', null, `${field}: `), messages.join(', '))
        )
      )
  );
};

export const formatError = (error: ApiError): string => {
  const body = error?.body as ValidationError | undefined;

  if (body?.errors) {
    const errorMessages = Object.entries(body.errors)
      .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
      .join('; ');

    return `${body.title ?? 'Validation failed'} ${errorMessages}`;
  }

  return body?.title ?? error.message ?? 'Something went wrong';
};
